export type ExternalServiceConfig = {
  localBaseUrl: string;
  serverBaseUrl: string;
  basePath: string;
  timeout?: number;
};

export const BizAppConfig = {
  // 应用名称
  appName: '建筑聘才',

  // API 地址（本地代理目标 / 线上直连目标）
  appApiUrlLocal: process.env.REACT_APP_API_URL || 'http://localhost:3000',
  appApiUrlServer:
    process.env.REACT_APP_API_URL || 'https://login.luoleshangcai.com',
  // 兼容旧代码中使用 appApiUrl 的场景
  appApiUrl:
    process.env.REACT_APP_API_URL || 'https://workbenchapi.zhiyueyun.com',

  // ============ 新建应用需要修改！！！ ============
  // SSO 客户端ID（优先读取环境变量，否则用默认值）
  appSsoClientId:
    process.env.REACT_APP_SSO_CLIENT_ID || '939e827ac2bc4fa9b8aa8b0ea1e94e65',

  // SSO 授权地址
  appSsoAuthorizeUrl:
    process.env.REACT_APP_SSO_AUTHORIZE_URL ||
    'https://app.yeeauth.com/oauth/authorize',

  // 默认 app_id（未传 app_id 时兜底，从 env 取）
  defaultSsoAppId:
    process.env.REACT_APP_SSO_DEFAULT_APP_ID ||
    '5536ba6fb542494cab8aebebb75068d9',

  // 默认 redirect_uri（未传 redirect_uri 时兜底，从 env 取）
  defaultSsoRedirectUri:
    process.env.REACT_APP_SSO_DEFAULT_REDIRECT_URI ||
    'https://jianzhupincai.com/callback',

  // 服务配置
  services: {
    main: {
      localBaseUrl: process.env.REACT_APP_API_URL || 'http://localhost:3000',
      serverBaseUrl:
        process.env.REACT_APP_API_URL || 'https://login.luoleshangcai.com',
      basePath: '/',
      timeout: 15000,
    },
    task: {
      localBaseUrl: process.env.REACT_APP_API_URL || 'http://localhost:3000',
      serverBaseUrl:
        process.env.REACT_APP_API_URL || 'https://task.zhiyueyun.com',
      basePath: '/',
      timeout: 15000,
    },
  } as Record<string, ExternalServiceConfig>,
};
